<template>
  <div class="w-full ">
    <!-- Bağlantı Durumu -->
    <div
      v-if="!isLive"
      class="p-2 mb-2 text-xs rounded-lg bg-yellow-50 border border-yellow-200 text-yellow-800 flex items-center justify-between"
    >
      <span>Canlı bağlantı yeniden kuruluyor…</span>
      <button type="button" class="underline" @click="refresh()">Yenile</button>
    </div>

    <!-- Masaüstü Bildirim İzni -->
    <div
      v-if="permission === 'default'"
      class="p-2 mb-2 text-xs rounded-lg bg-blue-50 border border-blue-200 text-blue-800 flex items-center justify-between"
    >
      <span>Masaüstü bildirimleri kapalı.</span>
      <button
        type="button"
        class="px-3 py-1 bg-blue-500 text-white rounded-lg"
        @click="requestPermission()"
      >
        Aç
      </button>
    </div>
    <div
      v-else-if="permission === 'denied'"
      class="p-2 mb-2 text-xs rounded-lg bg-red-50 border border-red-200 text-red-800"
    >
      Masaüstü bildirimleri bu tarayıcıda engellenmiş. Adres çubuğundaki kilit
      simgesinden "Bildirimler"e izin verip sayfayı yenileyin.
    </div>
    <div
      v-else-if="permission === 'unsupported'"
      class="p-2 mb-2 text-xs rounded-lg bg-gray-50 border text-gray-600"
    >
      Bu tarayıcı masaüstü bildirimlerini desteklemiyor. iPhone/iPad'de siteyi
      ana ekrana ekleyip oradan açın.
    </div>
    <div
      v-else-if="permission === 'granted'"
      class="p-2 mb-2 text-xs rounded-lg border text-gray-600"
    >
      <div class="flex items-center justify-between">
        <span>Masaüstü bildirimleri açık.</span>
        <button type="button" class="underline" @click="testDesktop()">
          Test et
        </button>
      </div>
      <div v-if="testOutcome" class="mt-1">
        <template v-if="testOutcome.indexOf('shown') === 0">
          Test bildirimi gönderildi. Görmediyseniz işletim sisteminin bildirim
          ayarlarını (Windows: Odaklanma yardımı, macOS: Sistem Ayarları &gt;
          Bildirimler &gt; tarayıcınız) kontrol edin.
        </template>
        <template v-else>
          Test bildirimi gösterilemedi. Sayfayı yenileyip tekrar deneyin.
        </template>
      </div>
    </div>

    <!-- Sessize Alınan Kelimeleri Yönetme Arayüzü -->
    <div class="p-2 border text-xs  rounded-lg mb-2">
      <h2
        @click="showMutedKeywords = !showMutedKeywords"
        class="text-sm p-0 mb-0 font-medium cursor-pointer flex items-center justify-between "
      >
        <span>Sessize Alınan Kelimeler</span>
        <span>
          <svg v-if="showMutedKeywords" xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" viewBox="0 0 24 24"><path fill="currentColor" d="m12 10.108l-4.6 4.6L6.692 14L12 8.692L17.308 14l-.708.708z"/></svg>        
          <svg  v-else xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" viewBox="0 0 24 24"><path fill="currentColor" d="M12 14.379q-.161 0-.298-.053t-.267-.184L7.046 9.754q-.14-.14-.15-.344t.15-.364t.354-.16t.354.16L12 13.292l4.246-4.246q.14-.14.345-.15q.203-.01.363.15t.16.354t-.16.354l-4.389 4.388q-.13.131-.267.184q-.136.053-.298.053"/></svg>

        </span>
      </h2>

      <div v-show="showMutedKeywords" class="">
        <form @submit.prevent="addMutedKeyword()">
          <div class="flex space-x-2 mb-2">
            <input
              v-model="newMuteKeyword"
              type="text"
              placeholder="Sessize alınacak kelime"
              class="p-2 border rounded-lg flex-1"
            />
            <button
              type="submit"
              @click="addMutedKeyword"
              class="px-4 py-2 bg-blue-500 text-white rounded-lg"
            >
              Ekle
            </button>
          </div>
          <div class="flex flex-wrap">
            <div
              v-for="(keyword, index) in mutedKeywords"
              :key="index"
              class="border bg-gray-50 text-xs px-3 py-1 rounded-full mr-2 mb-2 flex items-center space-x-2"
            >
              <span>{{ keyword }}</span>
              <button
                @click="removeMutedKeyword(index)"
                class="text-red-500 font-bold"
              >
                ×
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Bildirim Listesi -->
    <div
      class="border bg-white rounded-lg text-left mb-1 w-full p-2"
      v-for="notification in filteredNotifications"
      :key="notification.key"
    >
      <div class="flex space-x-2 justify-between items-start">
        <div
          class="bg-blue-50 bg-opacity-40 p-2 flex items-center justify-center text-white rounded-lg"
        >
          <div
            class="bg-blue-500 rounded-full px-1 h-6 w-6 items-center justify-center flex"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M12 22q-.825 0-1.412-.587T10 20h4q0 .825-.587 1.413T12 22m-7-3q-.425 0-.712-.288T4 18q0-.425.288-.712T5 17h1v-7q0-2.075 1.25-3.687T10.5 4.2v-.7q0-.625.438-1.062T12 2q.625 0 1.063.438T13.5 3.5v.325q-.275.55-.4 1.125T13 6.125q-.25-.05-.488-.088T12 6q-1.65 0-2.825 1.175T8 10v7h8v-6.425q.45.2.963.313T18 11v6h1q.425 0 .713.288T20 18q0 .425-.288.713T19 19zM18 9q-1.25 0-2.125-.875T15 6q0-1.25.875-2.125T18 3q1.25 0 2.125.875T21 6q0 1.25-.875 2.125T18 9"
              />
            </svg>
          </div>
        </div>
        <div class="flex flex-1 flex-col items-start justify-start">
          <h3 class="font-medium m-0 mb-1 p-0 text-xs">
            <template v-if="notification.lead_name">{{ notification.lead_name }} </template>({{ notification.title }})
          </h3>
          <div class="text-xs">
            {{ notification.body }}
            <div style="font-size:9px">
              {{ notification.start }}
            </div>
            <a
              v-if="notification.lead_id"
              :href="'/leadDetail/' + notification.lead_id"
              class="global-button-xs"
              >Detay</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "./EventBus";
import notificationStore from "../../services/notificationStore";
import desktopNotify from "../../services/desktopNotify";

export default {
  data() {
    return {
      newMuteKeyword: "", // Yeni sessize alınacak kelime
      showMutedKeywords: true, // Sessize alınan kelimeler formunu gizle/göster
      testOutcome: null,
    };
  },
  computed: {
    // Liste ve sessize alınan kelimeler App.vue ile ortak store'dan gelir.
    filteredNotifications() {
      return notificationStore.visibleItems();
    },
    mutedKeywords() {
      return notificationStore.state.mutedKeywords;
    },
    isLive() {
      return notificationStore.state.connectionState === "connected";
    },
    permission() {
      return notificationStore.state.permission;
    },
  },
  methods: {
    getLead(id) {
      this.$router.push({ name: "leadDetail", params: { id } });
    },
    refresh() {
      notificationStore.sync(true);
    },
    // Tıklama içinden çağrıldığı için tarayıcı izin penceresini gösterir.
    requestPermission() {
      desktopNotify.request("panel-button");
    },
    testDesktop() {
      desktopNotify.test().then((outcome) => {
        this.testOutcome = outcome;
      });
    },
    // Sessize alınacak kelime ekleme
    addMutedKeyword() {
      if (notificationStore.addMutedKeyword(this.newMuteKeyword)) {
        this.newMuteKeyword = "";
        EventBus.$emit("newMutedKeywords", true);
      }
    },
    // Sessize alınan kelimeyi kaldırma
    removeMutedKeyword(index) {
      notificationStore.removeMutedKeyword(this.mutedKeywords[index]);
      EventBus.$emit("newMutedKeywords", true);
    },
    onRefresh() {
      notificationStore.sync();
    },
  },
  mounted() {
    desktopNotify.syncPermission();
    EventBus.$on("notificationReflesh", this.onRefresh);
  },
  beforeDestroy() {
    // Offcanvas her açılıp kapandığında dinleyici birikmesin.
    EventBus.$off("notificationReflesh", this.onRefresh);
  },
};
</script>
